import type { JSX } from "react";
import { AppRouter } from "./router.js";
import { AuthProvider } from "../features/auth/AuthProvider.js";
import { Toaster } from "@/ui/sonner.js";

export function App(): JSX.Element {
  return (
    <AuthProvider>
      <AppRouter />
      <Toaster richColors closeButton />
    </AuthProvider>
  );
}
